if (!customElements.get('product-media-rotation')) {
    customElements.define("product-media-rotation", class ProductMediaRotation extends HTMLElement {
        static get observedAttributes() {
            return ["open"];
        }
        constructor() {
            super()
            this.canvasWidth = 624
            this.canvasHeight = 624
            this.rotationTipImg = this.querySelector('.rotation-img')
            this.initStatus = true
        }

        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
                case "open":
                    if (this.initStatus) {
                        this.initImages();
                        this.initStatus = false
                    }
            }
        }
        initGlobal() {
            this.count = this.images.length
            this.currentIndex = 0
            this.startX = 0
            this.endX = 0
            this.initCanvas()
            this.listenerEvent()
            this.querySelector('.rotation-loading').remove()
            this.rotationTipImg.classList.add('opacity')
        }
        updateCanvasView() {
            this.canvasWidth = 640 * window.devicePixelRatio
            this.canvasHeight = 640 * window.devicePixelRatio
            this.canvas.width = this.canvasWidth
            this.canvas.height = this.canvasHeight
            // 重新绘画
            // this.drawCanvas(this.currentIndex)
        }
        initCanvas() {
            this.canvas = this.querySelector('#product-media-rotation-canvas')
            this.context = this.canvas.getContext("2d")
            this.drawCanvas(this.currentIndex)
            // this.updateCanvasView()
            // this.listenerResize()
        }

        listenerResize() {
            // window.addEventListener('resize', () => {
            //     this.debounce(() => {
            //         this.updateCanvasView()
            //     }, 300)
            // })
        }
        initImages() {
            this.images = []
            let imgData = JSON.parse(this.querySelector('#product_media_rotation_json').innerText)
            let loadedCount = 0;
            imgData.images.forEach((url, i) => {
                const img = new Image();
                img.src = url;
                img.onload = () => {
                    loadedCount++
                    this.images[i] = img
                    if (loadedCount == imgData.images.length) {
                        this.initGlobal()
                    }
                };
            })

        }
        listenerEvent() {
            let dragging = false



            const startEvent = (e) => {
                dragging = true
                this.startX = e.clientX || e.touches[0].clientX || 0;
                this.rotationTipImg.classList.remove('opacity')
                this.classList.add('grabbing')
                this.addEventListener('mousemove', moveEvent);
                this.addEventListener('touchmove', moveEvent);
            }
            const endEvent = () => {
                dragging = false;
                this.rotationTipImg.classList.add('opacity')
                this.classList.remove('grabbing')
                this.removeEventListener("mousemove", moveEvent);
                this.removeEventListener('touchmove', moveEvent);
            }

            const moveEvent = (e) => {
                e.stopPropagation()
                e.preventDefault()
                if (dragging != true) return false;
                this.endX = (e.clientX || e.touches[0].clientX);
                let diff = this.endX - this.startX;
                this.drawCanvas(this.currentIndex)
                if (Math.abs(diff) >= 5) {
                    this.startX = this.endX;
                    if (diff > 0) {
                        // 向右拖动
                        this.currentIndex = (this.currentIndex + 1) % this.count;
                    } else {
                        // 向左拖动
                        this.currentIndex = (this.currentIndex - 1 + this.count) % this.count;
                    }
                    this.drawCanvas(this.currentIndex)
                }
            }


            this.addEventListener('mousedown', startEvent);
            this.addEventListener('touchstart', startEvent);
            document.addEventListener('mouseup', endEvent);
            document.addEventListener('touchend', endEvent);

        }
        drawCanvas(index) {
            // 当前序列帧
            const imgTemp = this.images[index];
            if (imgTemp) {
                this.context.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
                this.context.drawImage(imgTemp, 0, 0, this.canvasWidth, this.canvasHeight);
            }
        }
        debounce(fn, delay3) {
            let timer = null;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    fn.apply(this, args);
                }, delay3);
            };
        }


    })
}